import dayjs, { type Dayjs } from 'dayjs';

/** When a custom status clears itself, as offered in the status dialog. */
export type Expiry = 'never' | '30m' | '1h' | 'today' | 'week';

/** The moment an expiry choice ends, from now; undefined for "don't clear". */
export function expiryTime(e: Expiry, now: Dayjs = dayjs()): string | undefined {
  switch (e) {
    case 'never':
      return undefined;
    case '30m':
      return now.add(30, 'minute').toISOString();
    case '1h':
      return now.add(1, 'hour').toISOString();
    case 'today':
      return now.endOf('day').toISOString();
    case 'week':
      // The end of Sunday. dayjs weeks run Sunday to Saturday, so on a Sunday
      // that is tonight, and on any other day the coming Sunday.
      return now.day() === 0
        ? now.endOf('day').toISOString()
        : now.endOf('week').add(1, 'day').toISOString();
  }
}
